import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/main.css'

ReactDOM.render(<App />, document.querySelector('#root'));
